import { Menu } from "@headlessui/react";

export const TableMenuButton = ({ children }) => (
  <Menu.Button className="flex items-center rounded-full text-slate-400 bg-slate-100 hover:text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-slate-100 smooth-all">
    <span className="sr-only">Open options</span>
    {children}
  </Menu.Button>
);
